import { FunctionComponent } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useNotification } from '@starjack/features/notifications';
import { HospitalityUserWithCredentials } from '@/models/hospitality';
import { useDeleteHospitalityMutation } from '@/api/v2/hospitality';

type HospitalityDeleteDialogProps = {
    hospitality: HospitalityUserWithCredentials;
    open: boolean;
    onClose: () => void;
};

export const HospitalityDeleteDialog: FunctionComponent<
    HospitalityDeleteDialogProps
> = ({ hospitality, open, onClose }) => {
    const [deleteHospitality, { isLoading }] = useDeleteHospitalityMutation();
    const { addNotification } = useNotification();

    const onRefundTicket = () => {
        deleteHospitality(hospitality)
            .unwrap()
            .then(() => {
                addNotification({
                    message: 'Hospitality erfolgreich gelöscht',
                    type: 'success',
                });
            })
            .catch(() => {
                addNotification({
                    message:
                        'Fehler beim Löschen des Hospitality-Eintrags. Bitte später noch einmal versuchen',
                    type: 'error',
                });
            })
            .finally(() => {
                onClose();
            });
    };

    return (
        <Dialog open={open}>
            <DialogTitle>Hospitality löschen</DialogTitle>
            <DialogContent>
                {!!hospitality && (
                    <DialogContentText>
                        Soll der Hospitality User{' '}
                        <Typography sx={{ fontWeight: 600 }} component='span'>
                            {hospitality.name}
                        </Typography>{' '}
                        wirklich gelöscht werden?
                    </DialogContentText>
                )}
            </DialogContent>

            <DialogActions>
                <Stack spacing={2} direction='row'>
                    <Button onClick={onClose}>Abbrechen</Button>
                    <LoadingButton
                        onClick={onRefundTicket}
                        variant='contained'
                        loading={isLoading}
                    >
                        Löschen
                    </LoadingButton>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};
